import HTTP from '@/axios-auth';
import PayloadInsertCandidate from '../entities/payloadInsertCandidate';
import ResponseCandidate from '../entities/responseCandidate';
import CandidateRepository from './CandidateRepository';
import ResponseCandidateFull from '@/modules/candidate/entities/responseCandidateFull';

export default class CandidateRepositoryAPI implements CandidateRepository {
  async insertCandidate(candidate: PayloadInsertCandidate): Promise<ResponseCandidate> {
    const url = `/candidato`;
    
    // Use PUT if candidate has ID (update), POST if no ID (insert)
    const res = candidate.id 
      ? await HTTP.put(url, candidate)
      : await HTTP.post(url, candidate);
      
    return res.data;
  }

  async findByCpfDataNascimento(cpf: string, dataNascimento: string): Promise<ResponseCandidate> {
    const url = `/candidato/${cpf}/${dataNascimento}`;
    // console.group('findByCpfDataNascimento');
    // console.log('URL:', url);
    // console.groupEnd();
    try {
      const res = await HTTP.get(url);
      return res.data;
    } catch (error) {
        console.error('Error fetching candidate by CPF and date of birth:', error);
        throw error; // Re-throw the error to handle it in the calling code
    }
  }

  async findByCpf(): Promise<ResponseCandidateFull> {
    const url = `/candidato/dados`;

    // console.group('findByCpf');
    // console.log('URL:', url);
    // console.groupEnd();

    const res = await HTTP.get(url);
    return res.data;
  }
}
